export const ethnicity = [
  "African American",
  "Asian",
  "Caucasian",
  "Hispanic or Latino",
  "Native American",
  "Pacific Islander",
  "Navajo", // auto reverts to this upon successful CIB verification
  "Other",
];